import api from './api';
import usersService from './usersService';
import subscriptionService from './subscriptionService';
import helpSupportService from './helpSupportService';
import statesService from './statesService';
import citiesService from './citiesService';

const dashboardService = {
  getStats: async () => {
    try {
      // Fetch all data in parallel
      const [userStats, subscriptionStats, supportStats, states, cities, recentUsers] = await Promise.all([
        api.get('/users/stats'),
        api.get('/subscription/stats'),
        api.get('/help-support/admin/stats'),
        statesService.getAll(),
        citiesService.getAll(),
        usersService.getAll({ page: 1, limit: 5 }),
      ]);

      return {
        stats: {
          totalUsers: userStats.data?.totalUsers || 0,
          activeUsers: userStats.data?.activeUsers || 0,
          verifiedProfiles: userStats.data?.verifiedProfiles || 0,
          totalSubscriptions: subscriptionStats.data?.totalSubscriptions || 0,
          activeSubscriptions: subscriptionStats.data?.activeSubscriptions || 0,
          totalRevenue: subscriptionStats.data?.totalRevenue || 0,
          totalTickets: supportStats.data?.totalTickets || 0,
          openTickets: supportStats.data?.openTickets || 0,
          totalStates: Array.isArray(states) ? states.length : 0,
          totalCities: Array.isArray(cities) ? cities.length : 0,
        },
        recentUsers: recentUsers.users || [],
      };
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },
};

export default dashboardService;
